class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    const details = this.querySelector('details');
    const summary = this.querySelector('summary');
    if (!details || !summary) return;

    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

    summary.addEventListener('click', () => {
      requestAnimationFrame(() => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }
}

customElements.define('collapsible-content', CollapsibleContent);
